import FuzzySet from "fuzzyset";
import _ from "lodash";
import un from "underts";
import { demandeToWords } from "../../cadendar-consts.js";
//ne comprend que les séances qui peuvent être demandées par des patients.
//les séances de prothèse programmées avec le praticien ne peuvent pas être inclues
const fouzySet = FuzzySet(Object.values(demandeToWords).flat(1), true, 3, 3);
export default (words) => {
    const splitedWords = words.split(" ").filter((word) => word.length > 2);
    const foundWords = _.compact(splitedWords.map((word) => {
        const wordDebug = word;
        const candidate = fouzySet.get(word, undefined, 0.55);
        if (candidate) {
            return un.first(candidate)[1];
        }
        return null;
    }));
    return _.uniq(foundWords
        .map((word) => {
        return Object.entries(demandeToWords).reduce((result, [key, words]) => {
            //@ts-ignore
            if (words.includes(word)) {
                result.push(key);
            }
            return result;
        }, []);
    })
        .flat(1)).sort();
};
//# sourceMappingURL=wordsToDemandes.js.map